import parse from "html-react-parser"
import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import ImageScrollZoom from "../../common/imageScrollZoom"
import Title from "../../common/title"
import "./blockTextFullMediaGeneric.scss"
import { getSrc } from "gatsby-plugin-image"

const BlockTextFullMediaGeneric = ({ content }) => {
  const background = content.relationships.block_text_full_media_media
    ? getSrc(content.relationships.block_text_full_media_media.relationships
      .field_image.gatsbyImage)
    : ""
  return (
    <section className="blk-text-media-generic blk-spacing">
      <Container>
        <Row>
          <Col xs={12} className="blk-text-media-full-generic-content">
            <span className="caption">
              <span>{content.block_text_full_media_caption}</span>
            </span>
            <Title size={3} text={content.block_text_full_media_title} />
            {parse(content.block_text_full_media_desc.processed)}
          </Col>
          <Col xs={12} className="blk-text-media-full-generic-image">
            <ImageScrollZoom imageSrc={background} />
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default BlockTextFullMediaGeneric
